import {PRICES_CITIES} from "@pg-rp/navigation";

type PricesCitySlug = (typeof PRICES_CITIES)[number]["slug"];

export const PRICES_HUB_HERO_CITY_SLUGS = ["warszawa", "krakow", "wroclaw", "lodz"];

export const PRICES_HUB_OFFERS_ALL_CITIES = "all";
export const PRICES_HUB_OFFERS_CITY_SLUGS = ["warszawa", "krakow", "lodz", "poznan", "gdansk", "szczecin", "katowice"];

// Kept out of the transaction prices table for now, even when the registry has a settled quarter for them.
// Removing a slug from here brings the city back - no other change needed.
export const PRICES_HUB_TRANSACTION_EXCLUDED_CITY_SLUGS: PricesCitySlug[] = ["gdansk"];
import {PRICES_CITIES} from "@pg-rp/navigation";

type PricesCitySlug = (typeof PRICES_CITIES)[number]["slug"];

export const PRICES_HUB_HERO_CITY_SLUGS = ["warszawa", "krakow", "wroclaw", "lodz"];

export const PRICES_HUB_OFFERS_ALL_CITIES = "all";
export const PRICES_HUB_OFFERS_CITY_SLUGS = ["warszawa", "krakow", "lodz", "poznan", "gdansk", "szczecin", "katowice"];

// Kept out of the transaction prices table for now, even when the registry has a settled quarter for them.
// Removing a slug from here brings the city back - no other change needed.
export const PRICES_HUB_TRANSACTION_EXCLUDED_CITY_SLUGS: PricesCitySlug[] = ["gdansk"];
